import Path from "path";
import Fs from "fs";

import { cp } from "shelljs";

const targetDir = Path.join(__dirname, "..", "StaticFilesForProductionResourcesDir");
assertDirectoryExists(targetDir);
const sourceDir = Path.join(__dirname, "..", "StaticFilesForResourcesDir");
assertDirectoryExists(sourceDir);

cp("-f", `${sourceDir}/*`, targetDir);

function assertDirectoryExists(path: string) {
    if (!Fs.existsSync(path)) {
        throw new Error(`${path} doesn't exists; Build client.js first.`);
    }
}
